<template>
  <div id="login">
    <div class="login-wrap">
      <img src="../image/login-logo.png" class="img-logo-class"/>
<!--      <el-row type="flex" justify="center">-->
        <el-form ref="loginForm" :model="user"  status-icon label-width="80px">
          <div class="title-class">山东康为医药有限公司</div>
<!--          <h3>登录</h3>-->
<!--          <img src="../image/logo.png" class="img-logo-class"/>-->
<!--          <hr>-->
          <el-form-item prop="username" label="用户名">
            <el-input v-model="user.username" placeholder="请输入用户名" prefix-icon class="input-class"></el-input>
          </el-form-item>
          <el-form-item id="password" prop="password" label="密码">
            <el-input v-model="user.password" show-password placeholder="请输入密码" class="input-class"></el-input>
          </el-form-item>
<!--          <router-link to="/">找回密码</router-link>-->
<!--          <router-link to="/register">注册账号</router-link>-->
<!--          <el-form-item style="display: flex">-->
<!--            <el-button type="primary" @click="toHome()">首页</el-button>-->
<!--            <el-button type="primary" icon="el-icon-upload" @click="doLogin()">登 录</el-button>-->
<!--          </el-form-item>-->
          <div class="button-class">
            <el-row>
              <el-col :span="12"><div class="grid-content bg-purple">
                <el-button type="success" icon="el-icon-s-shop" @click="toHome()" >首页</el-button>
              </div></el-col>
              <el-col :span="12"><div class="grid-content bg-purple-light">
                <el-button type="primary" icon="el-icon-upload" @click="doLogin()">登 录</el-button>
              </div></el-col>
            </el-row>
          </div>
        </el-form>
<!--      </el-row>-->
    </div>
  </div>
</template>

<script>
import {login, loginToken} from '../../api'
export default {
  name: "login",
  data() {
    return {
      user: {
        username: "",
        password: ""
      }
    };
  },
  created() {},
  methods: {
    doLogin() {
      var md5 =require("md5");
      if (!this.user.username) {
        this.$message.error("请输入用户名！");
        return;
      } else if (!this.user.password) {
        this.$message.error("请输入密码！");
        return;
      } else {
        let password = md5(this.user.password);
        //校验用户名和密码是否正确;
        // this.$router.push({ path: "/personal" });
        // axios
        //   .post("/login/", {
        //     name: this.user.username,
        //     password: this.user.password
        //   })
        //   .then(res => {
        //     // console.log("输出response.data.status", res.data.status);
        //     if (res.data.status === 200) {
        //       this.$router.push({ path: "/personal" });
        //     } else {
        //       alert("您输入的用户名或密码错误！");
        //     }
        //   });

        // loginToken({
        //   username:this.user.username,
        //   password:this.user.password
        // }).then(res=>{
        //   console.log(res);
        //   if(res.data.code==200){
        //     localStorage.setItem("token",res.data.data.token);
        //     console.log(password);
            login({
              M_USERNAME:this.user.username,
              M_PASSWORD:password,
              M_ACTION:0
            }).then(res=>{
              console.log(res);
              //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
              // 请求返回数据
              let dataset = res.data.data.DATASET;
              if(dataset.length==0){
                this.$message.error('用户名密码不匹配或未绑定货主组织！');
                return false;
              }else{
                console.log(dataset[0]);
                sessionStorage.setItem("USERINFO",JSON.stringify(dataset[0]));
                let userInfo = {};
                userInfo.password = this.user.password;
                userInfo.username = this.user.username;
                localStorage.setItem("USERINFO",JSON.stringify(userInfo));
                this.$router.push('/home');
              }
            }).catch(err=>{
              // 请求失败执行
              console.log(err)
            })

        //   }else{
        //     this.$message.error(res.data.msg);
        //   }
        // }).catch(err=>{
        //   this.$message.error(err);
        // });

      }
    },
    toHome(){
      this.$router.push('/home');
    }
  },
  mounted() {
    if(localStorage.getItem("USERINFO") ==null || localStorage.getItem("USERINFO")==""){

    }else{
      this.user=JSON.parse(localStorage.getItem("USERINFO"));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  /*all:initial;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*background: url("../../assets/background.jpg");*/
  /*background-size: cover;*/
  /*overflow: hidden;*/
  /*background-position: center;*/

  background:url("../../assets/background.jpg");
  width:100%;
  height:100%;
  position:fixed;
  background-size:100% 100%;
}


.login-wrap {
  /*background: url("../../assets/background.jpg") no-repeat;*/
  background-size: cover;
  width: 400px;
  height: 350px;
  margin: 215px auto;
  overflow: hidden;
  padding-top: 10px;
  line-height: 40px;
  background-color: #B0B0B0;
  text-align: center;
}
#password {
  margin-bottom: 5px;
}
h3 {
  /*color: #0babeab8;*/
  font-size: 24px;
}

.title-class{
  font-size: 24px;
  padding-bottom: 10px;
}
hr {
  background-color: #444;
  margin: 20px auto;
}
a {
  text-decoration: none;
  color: #aaa;
  font-size: 15px;
}
a:hover {
  color: coral;
}
.el-button {
  width: 80%;
  margin-left: -50px;
}

.img-logo-class{
  /*height: 90px;*/
  /*margin-top: 10px;*/
  /*position: relative;*/
  all:initial;
  width: 60px;
  height: 60px;
  /*cursor: pointer;*/
  text-align: center;
}
.button-class{
  margin-top: 50px;
  width: 100%;
  padding-left: 25px;
}
.input-class{
  width: 80%;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login.vue